var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",attrs:{"data-posx":_vm.position.x,"data-posy":_vm.position.y}},[_c('div',{staticClass:"x-mark"},[_vm._v("X")]),_c('div',{staticClass:"marker-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }